import { render } from "./MetadataEditor.vue?vue&type=template&id=0f9abd5c&ts=true"
import script from "./MetadataEditor.vue?vue&type=script&lang=ts"
export * from "./MetadataEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__